import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<p\n  class=\"cost-estimator-footer__estimate-label\"\n  data-test-cost-estimator-footer-label\n>\n  {{yield}}\n</p>")